import {
  setCookie,
  getCookie,
  deleteCookie,
} from 'shared/helpers/utils/cookie';
import {
  COOKIE_EXPIRY_DAYS,
  GEO_LAT,
  GEO_LONG,
  LS_DELIVERY_ADDRESS,
  LS_DELIVERY_LOCALITY,
} from '@nykaa/map-picker';

export {
  COOKIE_EXPIRY_DAYS,
  DEFAULT_ADDRESS_PARTS_COUNT,
  DEFAULT_DOMAIN,
  // DELIVERY_ADDRESS_CHANGED_EVENT,
  ERROR_FETCHING_CITY,
  ERROR_FETCHING_GEO_DETAILS,
  ERROR_FETCHING_SERVICEABILITY,
  ERROR_NO_GEOMETRY,
  GEO_LAT,
  GEO_LONG,
  LS_DELIVERY_ADDRESS,
  LS_DELIVERY_LOCALITY,
  ROUTE_SELECT_DELIVERY_LOCATION,
} from '@nykaa/map-picker';

// function notifyAddressChanged() {
//   try {
//     window.dispatchEvent(new Event(DELIVERY_ADDRESS_CHANGED_EVENT));
//   } catch {
//     // SSR or unsupported
//   }
// }

export function updateDeliveryAddress(locality: string, fullAddress: string) {
  if (__SERVER__) return;
  try {
    localStorage.setItem(LS_DELIVERY_LOCALITY, locality);
    localStorage.setItem(LS_DELIVERY_ADDRESS, fullAddress);
  } catch {
    // localStorage unavailable
  }
  deleteCookie(GEO_LAT);
  deleteCookie(GEO_LONG);
  // notifyAddressChanged();
}

export function updateDeliveryLocation(
  locality: string,
  fullAddress: string,
  lat: number,
  long: number
) {
  if (__SERVER__) return;
  try {
    localStorage.setItem(LS_DELIVERY_LOCALITY, locality);
    localStorage.setItem(LS_DELIVERY_ADDRESS, fullAddress);
  } catch {
    // localStorage unavailable
  }
  setCookie(GEO_LAT, String(lat), COOKIE_EXPIRY_DAYS);
  setCookie(GEO_LONG, String(long), COOKIE_EXPIRY_DAYS);
  // notifyAddressChanged();
}

export function clearDeliveryAddress() {
  if (__SERVER__) return;
  try {
    localStorage.removeItem(LS_DELIVERY_LOCALITY);
    localStorage.removeItem(LS_DELIVERY_ADDRESS);
  } catch {
    // localStorage unavailable
  }
  deleteCookie(GEO_LAT);
  deleteCookie(GEO_LONG);
  // notifyAddressChanged();
}

export function getDeliveryLatLong(): { lat: string; long: string } | null {
  if (__SERVER__) return null;
  const lat = getCookie(GEO_LAT)?.toString();
  const long = getCookie(GEO_LONG)?.toString();
  if (lat && long) {
    return { lat, long };
  }
  return null;
}
